import moment from 'moment';
import classnames from 'classnames/bind';
import { DateRange } from 'react-date-range';
import { AnimatePresence, motion } from 'framer-motion';
import { Popover } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';

import styles from './DateRangePicker.module.css';

const cls = classnames.bind(styles);

export const DateRangePicker = ({ dateRange, onChange }) => {
  const [startDate, endDate] = dateRange;

  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <Popover.Button className={cls('button')}>
            <span className={cls('button__date')}>
              {moment(startDate).format('DD.MM.YYYY')} - {moment(endDate).format('DD.MM.YYYY')}
            </span>

            <ChevronDownIcon className={cls('button__icon')} />
          </Popover.Button>

          <AnimatePresence>
            {open && (
              <Popover.Panel
                static
                as={motion.div}
                initial={{ y: 10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 10, opacity: 0 }}
                transition={{ duration: 0.2, ease: 'easeOut' }}
                className={cls('popover')}
              >
                <DateRange
                  ranges={[{ startDate, endDate, key: 'selection' }]}
                  retainEndDateOnFirstSelection={true}
                  onChange={({ selection }) => {
                    onChange(selection);
                  }}
                  staticRanges={[]}
                  inputRanges={[]}
                />
              </Popover.Panel>
            )}
          </AnimatePresence>
        </>
      )}
    </Popover>
  );
};
